import gql from 'graphql-tag';
import AdminProductAllData from '../fragments/AdminProductAllData';

export default gql`
mutation adminUpdateProduct (
    $id: ID!
    $status: ProductStatus
    $gift_message_available: Boolean
    $is_mpl: Boolean
    $description: String
    $components: String
    $nutrition_data: String
    $meta_title: String
    $meta_description: String
    $meta_keywords: String
    $min_expiry_days: Int
    $sliceable: Boolean
    $weight: Int
    $attribute_option_ids: [ID]!
    $category_ids: [ID]!
    $alternative_quantity_scale: Float
    $alternative_quantity_minimum: Int
    $alternative_quantity_exchange_rate: Float
    $alternative_quantity_name: ProductAlternativeQuantityName
    $default_quantity_minimum: Float
    $default_quantity_scale: Float
    $is_qty_decimal: Boolean
    $webshop_only_price: Boolean
) {
    adminUpdateProduct (input: {
        id: $id,
        status: $status,
        gift_message_available: $gift_message_available,
        is_mpl: $is_mpl,
        description: $description,
        components: $components,
        nutrition_data: $nutrition_data,
        meta_title: $meta_title,
        meta_description: $meta_description,
        meta_keywords: $meta_keywords,
        min_expiry_days: $min_expiry_days,
        sliceable: $sliceable,
        weight: $weight,
        attribute_option_ids: $attribute_option_ids,
        category_ids: $category_ids,
        alternative_quantity_scale: $alternative_quantity_scale,
        alternative_quantity_minimum: $alternative_quantity_minimum,
        alternative_quantity_exchange_rate: $alternative_quantity_exchange_rate,
        alternative_quantity_name: $alternative_quantity_name,
        default_quantity_scale: $default_quantity_scale,
        default_quantity_minimum: $default_quantity_minimum,
        is_qty_decimal: $is_qty_decimal,
        webshop_only_price: $webshop_only_price,
    }) {
        ...AdminProductAllData
    }
}
${AdminProductAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminUpdateProduct.ts